import { LocationScope, MergedLocationVar, LocationVarInheritance } from "@swivl-mono/types";
import { InheritancePill, Spinner } from "@swivl-mono/ui";
import "./WorksheetComponent.Label.scss";

interface Props {
	text?: string;
	inheritance: LocationVarInheritance;
	isEditing: boolean
	type: LocationScope
	canRevert: boolean
	isLoading: boolean
	deleteVariable(): void
	inline?: boolean

}

export function WorksheetComponentLabel(props: Props) {
	const { inheritance, isEditing, isLoading, deleteVariable } = props;
	const revert = () => {
		if (confirm('Are you sure you want to revert this variable?')) {
			deleteVariable()
		}
	}

	return (
		<div className={`WorksheetComponentLabel ${props.inline ? "inlineLabel" : ""}`}>
			<div className="labelText">
				{isLoading ? <Spinner /> : props.text || ""}
			</div>
			<InheritancePill inheritance={inheritance} isEditing={isEditing} canRevert={props.canRevert} onClick={revert} />
		</div>
	)

}

